import { z } from 'zod/v4';
import {
  ACCESSIBLE_IMAGE_SCHEMA,
  DEFAULT_ACCESSIBLE_IMAGE_EMPTY,
  DEFAULT_ACCESSIBLE_IMAGE_LOGO,
  IAccessibleImage,
} from './image.interfaces';
import { EEntityType, ERelationType } from './text-relation-type.enums';
import { ETextType } from './text/text.enums';
import {
  INormalText,
  NORMAL_TEXT_SCHEMA,
  NormalTextId,
  TextId,
  TextLanguageValueId,
} from './text/text.interfaces';
import { Brand } from '../branded-types';
import { LanguagePrefix } from './language.interfaces';

export type HeaderId = Brand<string, 'headerId'>;

export const HEADER_SCHEMA: z.ZodType<IHeader> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as HeaderId)
    .optional(),
  logo: ACCESSIBLE_IMAGE_SCHEMA,
  backgroundColor: z.string(),
  fontColor: z.string(),
  headlines: z.array(NORMAL_TEXT_SCHEMA),
  headlineFontSize: z.number(),
  leftImage: ACCESSIBLE_IMAGE_SCHEMA,
  rightImage: ACCESSIBLE_IMAGE_SCHEMA,
});

export interface IHeader {
  id?: HeaderId;
  logo: IAccessibleImage;
  backgroundColor: string;
  fontColor: string;
  headlines: INormalText[];
  headlineFontSize: number;
  leftImage: IAccessibleImage;
  rightImage: IAccessibleImage;
}

export const DEFAULT_HEADER: IHeader = {
  id: 'db0a12d5-2290-41bf-87c3-16c63c41b719' as HeaderId,
  logo: DEFAULT_ACCESSIBLE_IMAGE_LOGO,
  backgroundColor: '#FFFFFF',
  fontColor: '#444444',
  headlines: [
    {
      id: 'cbb4972d-97aa-4b8c-8548-efbec6f76bea' as NormalTextId,
      textType: ETextType.Web,
      relationType: ERelationType.headline,
      entityType: EEntityType.header,
      text: {
        id: '193986ed-f02d-415d-8e24-8a057a41af9c' as TextId,
        values: [
          {
            id: 'db52d7ba-fc52-4191-941b-41043f56f437' as TextLanguageValueId,
            value: 'Software, die bewegt',
            languagePrefix: 'DE' as LanguagePrefix,
          },
        ],
      },
    },
  ],
  headlineFontSize: 32,
  leftImage: { ...DEFAULT_ACCESSIBLE_IMAGE_EMPTY },
  rightImage: { ...DEFAULT_ACCESSIBLE_IMAGE_EMPTY },
};
